import { render, staticRenderFns } from "./BajasCobranzaFilters.vue?vue&type=template&id=6a6a291e&"
import script from "./BajasCobranzaFilters.vue?vue&type=script&lang=ts&"
export * from "./BajasCobranzaFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6a6a291e', component.options)
    } else {
      api.reload('6a6a291e', component.options)
    }
    module.hot.accept("./BajasCobranzaFilters.vue?vue&type=template&id=6a6a291e&", function () {
      api.rerender('6a6a291e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/BajasCobranza/BajasCobranzaFilters.vue"
export default component.exports